/* Zombie Snacks — slime hover for the branded CTAs ("A. Pour", approved 29 Sep 2026)
 *
 * On hover / keyboard focus, Zombie slime oozes over the top edge of the pill,
 * drips run down at their own pace, a few drops fall ahead, then the body of
 * the slime floods down and the "goo" filter melts every drip into it. All of
 * it is clipped inside the button; the look + timing live in zombie-theme.css
 * ("Branded CTAs: slime fill").
 *
 * This file only ADDS decoration: one aria-hidden <span class="zombie-slime">
 * of plain shapes per button, plus the shared SVG goo filter. Taiga's button
 * markup, labels, links and behaviour are untouched, and without this script
 * (or with reduced motion, or on touch-only devices, where it does nothing)
 * the buttons still change colour on hover/focus via CSS.
 */
(function () {
  'use strict';

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fine.matches || reduced.matches) return;

  /* Same list as the CSS (zombie-theme.css + zombie-portal-hero.css + zombie-munch.css) */
  var SELECTOR = [
    '.zombie-portal .zombie-portal__btn',
    '[id$="__zombie-best-sellers"] .section-header .rte a:not(.btn)',
    '[id$="__zombie-best-sellers"] .card--product .quick-buy-or-add .btn',
    '.section--main-collection-product-grid .card--product .quick-buy-or-add .btn',
    '.section--product-recommendations .card--product .quick-buy-or-add .btn',
    '[id$="__zombie-cta"] .btn--primary',
    '[id$="__zombie-contact"] .btn--primary',
    '[id$="__zombie-locator"] .btn--primary',
    '[id$="__zombie-brain-zone"] .btn',
    '.zg-how__cta .btn--primary',            /* Monster Merge page (zombie-game-landing) */
    '.zg-board__more .btn--primary',         /* Monster Merge page (zombie-game-leaderboard, compact) */
    '.zg-subnav .zg-subnav__play',           /* game sub-nav PLAY NOW (zombie-game-subnav) */
    '.zg-board .zg-board__tab',              /* leaderboard MONTHLY / YEARLY / ALL TIME (zombie-game-leaderboard) */
    '.zg-board .zg-board__arrow',            /* leaderboard previous / next month */
    '.zg-board .zg-board__pager button',     /* leaderboard PREV / NEXT page */
    'footer.footer .newsletter-form .newsletter-form__button--text',
    '[id$="__zombie-join-horde"] .newsletter-form .newsletter-form__button--text',
    '.drawer .cart-footer [name="checkout"]',
    '.drawer .cart-footer .btn[type="submit"]',
    '.section--main-product .product-form__submit',
    '.product-buy-bar .product-form__submit',
    'zombie-munch .zm-btn',
    /* Build a Bundle (Route A, 20 Oct 2026): Appstle's own add-to-bundle and
       add-to-basket buttons; colours in zombie-bundle-builder.css */
    '#ab-dynamic-pricing-bundle .ab-add-product-button',
    '#ab-dynamic-pricing-bundle .ab-dynamic-bundle-checkout-button'
  ].join(',');

  /* the goo: blur the shapes, snap the alpha back to a hard edge so touching
     shapes merge like liquid; "atop" keeps the flat slime colour */
  function addFilter() {
    if (document.getElementById('zombie-goo')) return;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.style.position = 'absolute';
    svg.innerHTML =
      '<filter id="zombie-goo" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">' +
        '<feGaussianBlur in="SourceGraphic" stdDeviation="4.5" result="blur"/>' +
        '<feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -9" result="goo"/>' +
        '<feComposite in="SourceGraphic" in2="goo" operator="atop"/>' +
      '</filter>';
    document.body.appendChild(svg);
  }

  /* small seeded random, so each button gets its own (stable) run of drips */
  var seed = 7;
  function rnd(a, b) {
    seed = (seed * 16807) % 2147483647;
    return a + ((seed - 1) / 2147483646) * (b - a);
  }

  function build(btn) {
    var width = btn.getBoundingClientRect().width || 200;
    var n = Math.max(3, Math.min(8, Math.round(width / 44)));
    var html = '<i class="zs-lip"></i>';
    for (var i = 0; i < n; i++) {
      var w = Math.round(rnd(9, 16));
      var x = ((i + 0.5) / n) * 100 + rnd(-6, 6);
      html += '<i class="zs-drip" style="--x:calc(' + x.toFixed(1) + '% - ' + (w / 2) + 'px);--w:' + w + 'px;' +
        '--len:' + rnd(3.5, 9).toFixed(2) + ';--dur:' + Math.round(rnd(520, 820)) + 'ms;--delay:' + Math.round(rnd(0, 180)) + 'ms"></i>';
    }
    for (var j = 0; j < 3; j++) {
      var dw = Math.round(rnd(7, 11));
      html += '<i class="zs-drop" style="--x:calc(' + rnd(10, 90).toFixed(1) + '% - ' + (dw / 2) + 'px);--w:' + dw + 'px;' +
        '--delay:' + Math.round(rnd(20, 220)) + 'ms"></i>';
    }
    html += '<i class="zs-body"></i>';
    var layer = document.createElement('span');
    layer.className = 'zombie-slime';
    layer.setAttribute('aria-hidden', 'true');
    layer.innerHTML = html;
    btn.appendChild(layer);
    btn.classList.add('has-zombie-slime');
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('has-zombie-slime')) continue;
      /* an app (e.g. Appstle's React) can re-render a button's class list while
         keeping its children: re-mark it, never add a second slime layer */
      if (list[i].querySelector(':scope > .zombie-slime')) list[i].classList.add('has-zombie-slime');
      else build(list[i]);
    }
  }

  function init() {
    addFilter();
    scan(document);
    /* cart drawer, quick view and "load more" add buttons later */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
